import { render, staticRenderFns } from "./dashboardDataLoader.vue?vue&type=template&id=db320c8c&scoped=true"
import script from "./dashboardDataLoader.vue?vue&type=script&lang=js"
export * from "./dashboardDataLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db320c8c",
  null
  
)

export default component.exports